
import { useStore } from '@/store'
import {
  isLicenceNonCommercial,
  LicenceBillingType,
  LicenceProtectionType,
  LicenceType,
} from '@/types/Licence'
import Vue from 'vue'
import AddAccessData from '../types/AddAccessData'

export default Vue.extend({
  name: 'App',
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    licenceType: '',
    billingType: '' as LicenceBillingType,
    protectionType: '' as LicenceProtectionType,
    dialog: false,
    menu: false,
    step: 1,
    accessMembershipType: '',
    accesses: new Array<AddAccessData>(),
    numberOfSeats: 1,
  }),
  computed: {
    loading() {
      return this.$store.getters.loading
    },
    users() {
      return this.$store.getters.users
    },
    licenceTypeItems(): { text: string; value: string }[] {
      return useStore().licenceTypeItems
    },
    licenceBillingTypeItems(): { text: string; value: string }[] {
      return useStore().licenceBillingTypeItems
    },
    licenceProtectionTypeItems(): { text: string; value: string }[] {
      return useStore().licenceProtectionTypeItems
    },
    isYearlyFee(): boolean {
      return this.billingType !== 'monthly_fee'
    },
    isDisplayAdditionalFields(): boolean {
      return this.licenceType !== '' && !isLicenceNonCommercial(this.licenceType as LicenceType)
    },
  },
  methods: {
    async onSubmit() {
      const finalAccesses = new Array<{
        expirationDate: number
        membershipType: string
      }>()
      this.accesses.forEach((acc) => {
        finalAccesses.push({
          membershipType: acc.membershipType,
          expirationDate: new Date(acc.expiration).getTime(),
        })
      })

      const licenceData = {
        userId: this.$store.getters.inspectUser.id,
        type: this.licenceType,
        accesses: finalAccesses,
        availableSeatNumber: this.numberOfSeats,
        billingType: this.billingType,
        protectionType: this.protectionType,
      }

      await this.$store.dispatch('addUserLicence', licenceData)

      this.dialog = false
    },
    onAddAccess() {
      const accessData: AddAccessData = {
        id: this.accesses.length + 1,
        membershipType: this.accessMembershipType,
        expiration: this.date,
      }

      this.accesses.push(accessData)
    },
    onDeleteAccess(id: number) {
      this.accesses.splice(
        this.accesses.findIndex((access) => access.id === id),
        1
      )
    },
    capitalizeStr(str: string) {
      return str.charAt(0).toLocaleUpperCase() + str.slice(1)
    },
    daysToMs(days: number): number {
      return days * 24 * 60 * 60 * 1000
    },
  },
  watch: {
    loading: function (lhs, rhs) {
      if (lhs === 'true' && rhs === 'false') this.dialog = false
    },
    billingType(): void {
      let calculatedExpDate: number = Date.now()
      if (this.isYearlyFee) calculatedExpDate += this.daysToMs(365)
      else calculatedExpDate += this.daysToMs(30)

      this.date = new Date(calculatedExpDate).toISOString().split('T')[0]
    },
    licenceType(): void {
      const isNonCommercial = isLicenceNonCommercial(this.licenceType as LicenceType)

      this.billingType = ''
      this.protectionType = ''

      if (isNonCommercial) this.protectionType = 'online'
    },
  },
})
